<template>
    <div class="bg-gradient-loch">
      <a class="skip-main" href="#main">Skip to main content</a>
        <div class="home my-4 px-4 container">
            <div class="row mb-4">
                <div id="main" role="main" class="col-12">
                    <form ref="form" label-position="left" class="userform">
                        <div class="card shadow mx-auto mt-4 max-width-4 bg-light px-lg-5 px-md-0 px-lg-5">
                            <div class="card-body px-lg-5 text-left">
                                <h2 class="mb-4 mt-3">Forgot Password</h2>
                                <form-errors :errors="errors" aria-invalid='true'></form-errors>
                                <app-error :error="defaultError" aria-invalid='true'></app-error>
                                <app-success :success="defaultSuccess" aria-invalid='true'></app-success>
                                <div class="mt-3">
                                    <b-form-group label="Email Address" :class="{'has-error': defaultError}">
                                        <input :disabled="user" class="form-control" placeholder="Enter your email address" v-model="email">
                                    </b-form-group>
                                </div>
                                <div class="text-center mt-4"  v-if="!user" >
                                    <p>Not registered yet? <router-link to="/register"> Register Now</router-link></p>
                                </div>
                                <b-button class="full-green-btn mt-3" @click="submit()">
                                    <span>Submit <svg-icon v-if="name != 'sestran'" class="arrow-right-find" name="forward"></svg-icon></span>
                                </b-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mutationsMapping from '@/store/mutations-mapping'
import {
    mapState,
    mapMutations,
    mapActions,
} from 'vuex'
import AppError from '@/components/AppError.vue'
import AppSuccess from '@/components/AppSuccess.vue'
import FormErrors from '@/components/FormErrors.vue'

const whitelabel = require('../../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'ResetUserPassword',
    components: {
        AppError,
        AppSuccess,
        FormErrors,
    },
    data() {
        return {
            name: whitelabel.brand,
            email: '',
        }
    },
    computed: {
        ...mapState([
            'defaultError',
            'defaultSuccess',
            'user',
            'auth',
            'errors',
        ]),
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'passwordReset',
        ]),

        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },

        submit() {
            this.passwordReset({
                params: {
                    email: this.email,
                },
            })
        },
        prepareSumbit() {
            if (this.user) {
                this.email = this.user.email
            }
        },
    },
    mounted() {
        this.clearErrors()
        this.setDefaultSuccess(false)
        this.setDefaultError(false)
        this.prepareSumbit()
        if (this.user) {
            this.submit()
        }
    },
}
</script>
